import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect, useRef , useCallback } from 'react'

import Header from './componentes/header';
import SmoothScrollHero from './componentes/scroll';
import InfiniteScroll from './componentes/infinitescroll';
import './styles/index.css'
import PortfolioCarousel from './componentes/portfolio';
import ContactSection from './componentes/contact';
import FooterWithSocialLinks from './componentes/footer';
import Loader from './componentes/loader';
import Modal from './componentes/model';

import img1 from './assests/eng_webp/01.webp'
import img2 from './assests/eng_webp/02.webp'
import img3 from './assests/prewedding_webp/05.webp'
import img4 from './assests/haldi_webp/01.webp'

import img1Mobile from './assests/eng_webp/sv11.png'
import img2Mobile from './assests/prewedding_webp/prmb01.webp'
import img3Mobile from './assests/prewedding_webp/prmb02.webp'
import img4Mobile from './assests/wedding_webp/wemb01.webp'


const images = [
  { 
    src: img1, 
    srcMobile: img1Mobile, 
    text: "Capture Your Special Moments", 
    buttonText: "Contact Now" 
  },
  { 
    src: img2, 
    srcMobile: img2Mobile, 
    text: "Create Lasting Memories", 
    buttonText: "Contact Now" 
  },
  { 
    src: img3, 
    srcMobile: img3Mobile, 
    text: "Capture Your Special Moments", 
    buttonText: "Contact Now" 
  },
  { 
    src: img4, 
    srcMobile: img4Mobile, 
    text: "Create Lasting Memories", 
    buttonText: "Contact Now" 
  },
];

// function Carousel() {
//   const [[page, direction], setPage] = useState([0, 0]);
//   const [imageErrors, setImageErrors] = useState(Array(images.length).fill(false))

//   const paginate = useCallback((newDirection) => {
//     setPage(([currentPage]) => {
//       const nextPage = (currentPage + newDirection + images.length) % images.length;
//       return [nextPage, newDirection];
//     });
//   }, []);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       paginate(1);
//     }, 5000);

//     return () => clearInterval(timer);
//   }, [paginate]);

//   const handleImageError = (index) => {
//     console.error(`Error loading image at index ${index}:`, images[index].src)
//     setImageErrors(prev => {
//       const newErrors = [...prev]
//       newErrors[index] = true
//       return newErrors
//     })
//   }

//   const variants = {
//     enter: (direction) => {
//       return {
//         x: direction > 0 ? 1000 : -1000,
//         opacity: 0,
//         scale: 0.5,
//         rotateY: direction > 0 ? 45 : -45,
//       }
//     },
//     center: {
//       zIndex: 1,
//       x: 0,
//       opacity: 1,
//       scale: 1,
//       rotateY: 0,
//     },
//     exit: (direction) => {
//       return {
//         zIndex: 0,
//         x: direction < 0 ? 1000 : -1000,
//         opacity: 0,
//         scale: 0.5,
//         rotateY: direction < 0 ? -45 : 45,
//       }
//     }
//   }

//   const swipeConfidenceThreshold = 10000
//   const swipePower = (offset, velocity) => {
//     return Math.abs(offset) * velocity
//   }

//   return (
//     <section className="w-full py-8 md:py-8 lg:py-8 xl:py-8 bg-background">
//       <div className="container px-4 md:px-6 mx-auto">
//         <div className="flex flex-col items-center text-center">
//           <div className="md:hidden">
//             <h1 className="maintext text-4xl tracking-tighter sm:text-5xl">
//               Create Memories with us
//             </h1>
//           </div>
//         </div>
//         <div className="relative w-full max-w-full mx-auto overflow-hidden rounded-2xl border mt-8">
//           <div className="relative" style={{ paddingBottom: '56.25%' }}> {/* 16:9 aspect ratio */}
//             <AnimatePresence initial={false} custom={direction}>
//               <motion.div
//                 key={page}
//                 custom={direction}
//                 variants={variants}
//                 initial="enter"
//                 animate="center"
//                 exit="exit"
//                 transition={{
//                   x: { type: "spring", stiffness: 300, damping: 30 },
//                   opacity: { duration: 0.2 },
//                   scale: { duration: 0.4 },
//                   rotateY: { duration: 0.4 },
//                 }}
//                 className="absolute inset-0"
//                 drag="x"
//                 dragConstraints={{ left: 0, right: 0 }}
//                 dragElastic={1}
//                 onDragEnd={(e, { offset, velocity }) => {
//                   const swipe = swipePower(offset.x, velocity.x)
//                   if (swipe < -swipeConfidenceThreshold) {
//                     paginate(1)
//                   } else if (swipe > swipeConfidenceThreshold) {
//                     paginate(-1)
//                   }
//                 }}
//               >
//                <picture>
//   <source 
//     srcSet={images[page].srcMobile} 
//     media="(max-width: 768px)" 
//   />
//   <source 
//     srcSet={images[page].src} 
//     media="(min-width: 769px)" 
//   />
//   <img
//     loading="eager"
//     src={images[page].src} // Fallback image for browsers that don't support <picture>
//     alt={`Slide ${page + 1}`}
//     className="absolute inset-0 w-full h-full object-cover"
//     onError={() => handleImageError(page)}
//     style={{ display: imageErrors[page] ? 'none' : 'block' }}
//   />
// </picture>

//                 {imageErrors[page] && (
//                   <div className="absolute inset-0 flex items-center justify-center bg-gray-200 dark:bg-gray-800">
//                     <p className="text-red-500">Error loading image</p>
//                   </div>
//                 )}
//                 <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-0 text-white">
//                   <h2 style={{fontWeight:'400'}} className="text-3xl font-fontc md:text-4xl lg:text-5xl mb-4 hidden md:block">{images[page].text}</h2>
//                   <button className="mt-2 px-6 py-2 bg-white text-black rounded-full font-semibold hidden md:block">
//                     {images[page].buttonText}
//                   </button>
//                 </div>
//               </motion.div>
//             </AnimatePresence>
//           </div>
//           <button style={{ opacity:0 }}
//             className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-gray-800/80 rounded-full p-2 z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 dark:focus:ring-gray-600"
//             onClick={() => paginate(-1)}
//             aria-label="Previous slide"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//             </svg>
//           </button>
//           <button style={{ opacity:0 }}
//             className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 dark:bg-gray-800/80 rounded-full p-2 z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 dark:focus:ring-gray-600"
//             onClick={() => paginate(1)}
//             aria-label="Next slide"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//             </svg>
//           </button>
//         </div>
//         <div className="mt-8 flex justify-center space-x-2">
//           {images.map((_, index) => (
//             <motion.div
//               key={index}
//               className={`w-2 h-2 rounded-full ${
//                 index === page ? 'bg-gray-800 dark:bg-gray-200' : 'bg-gray-300 dark:bg-gray-600'
//               }`}
//               initial={false}
//               animate={{ scale: index === page ? 1.5 : 1 }}
//               transition={{ duration: 0.3 }}
//             />
//           ))}
//         </div>
//         <div className="sub-text flex flex-col md:hidden">
//           <div className="mt-10 text-center">
//             <h2 className="text-xl ">Beautiful Wedding, Mehendi, Haldi, and Pre Wedding Photography in Solapur  Capturing Your Special Moments.</h2>
//           </div>
//           <button style={{ fontSize:'1.2rem' }} className="mt-10 bg-gray-800 px-6 py-2 text-white rounded-full  self-center"><a href="https://api.whatsapp.com/send?phone=9130703656&text=Hello">Contact Now</a></button>
//         </div>
//       </div>
//     </section>
//   )
// }


// function Carousel() {
//   const [[page, direction], setPage] = useState([0, 0]);

//   const paginate = useCallback((newDirection) => {
//     setPage(([currentPage]) => {
//       const nextPage = (currentPage + newDirection + images.length) % images.length;
//       return [nextPage, newDirection];
//     });
//   }, []);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       paginate(1);
//     }, 5000);

//     return () => clearInterval(timer);
//   }, [paginate]);

//   const variants = {
//     enter: (direction) => ({
//       x: direction > 0 ? 1000 : -1000,
//       opacity: 0,
//     }),
//     center: {
//       zIndex: 1,
//       x: 0,
//       opacity: 1,
//     },
//     exit: (direction) => ({
//       zIndex: 0,
//       x: direction < 0 ? 1000 : -1000,
//       opacity: 0,
//     }),
//   };

//   const swipeConfidenceThreshold = 10000;
//   const swipePower = (offset, velocity) => {
//     return Math.abs(offset) * velocity;
//   };

//   return (
//     <div className="relative w-full h-screen overflow-hidden">
//       <AnimatePresence initial={false} custom={direction}>
//         <motion.div
//           key={page}
//           custom={direction}
//           variants={variants}
//           initial="enter"
//           animate="center"
//           exit="exit"
//           transition={{
//             x: { type: "spring", stiffness: 300, damping: 30 },
//             opacity: { duration: 0.2 },
//           }}
//           className="absolute w-full h-full"
//           drag="x"
//           dragConstraints={{ left: 0, right: 0 }}
//           dragElastic={1}
//           onDragEnd={(e, { offset, velocity }) => {
//             const swipe = swipePower(offset.x, velocity.x);
//             if (swipe < -swipeConfidenceThreshold) {
//               paginate(1);
//             } else if (swipe > swipeConfidenceThreshold) {
//               paginate(-1);
//             }
//           }}
//         >
//           <picture>
//             <source media="(min-width: 768px)" srcSet={images[page].src} />
//             <source media="(max-width: 767px)" srcSet={images[page].srcMobile} />
//             <img
//               src={images[page].src}
//               alt={`Slide ${page + 1}`}
//               className="w-full h-full object-cover"
//             />
//           </picture>
//           <div className="absolute inset-0 flex flex-col items-center justify-end bg-black bg-opacity-30 text-white">
//             <h2 className="text-3xl font-light md:text-4xl lg:text-5xl mb-8 px-4 text-center">{images[page].text}</h2>
//             <button className="mb-20 md:mb-16 px-6 py-2 bg-white text-black rounded-full font-semibold">
//               {images[page].buttonText}
//             </button>
//           </div>
//         </motion.div>
//       </AnimatePresence>
//       <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
//         {images.map((_, index) => (
//           <motion.div
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === page ? 'bg-white' : 'bg-white bg-opacity-50'
//             }`}
//             initial={false}
//             animate={{ scale: index === page ? 1.2 : 1 }}
//             transition={{ duration: 0.3 }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(images.length); // Start from the first real image
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const containerRef = useRef(null);
  const autoScrollTimerRef = useRef(null);
  const lastInteractionRef = useRef(Date.now());
  const [startY, setStartY] = useState(0);
  const [currentY, setCurrentY] = useState(0);

  // Cloning images for infinite scrolling
  const clonedImages = [...images, ...images, ...images];

  const startAutoScroll = useCallback(() => {
    if (autoScrollTimerRef.current) clearInterval(autoScrollTimerRef.current);
    autoScrollTimerRef.current = setInterval(() => {
      if (Date.now() - lastInteractionRef.current > 5000) {
        handleSlideChange(1, true);
      }
    }, 5000);
  }, []);

  useEffect(() => {
    startAutoScroll();
    return () => {
      if (autoScrollTimerRef.current) clearInterval(autoScrollTimerRef.current);
    };
  }, [startAutoScroll]);

  useEffect(() => {
    if (!isTransitioning) return;

    if (currentIndex >= images.length * 2) {
      // Wait for transition to complete before resetting
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(images.length);
      }, 300); // Match this with your transition duration
      return () => clearTimeout(timer);
    } 
    
    if (currentIndex < images.length) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(images.length * 2 - 1);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, isTransitioning]);

  

  const handleSlideChange = (direction, isAutoScroll = false) => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex + direction);

    if (!isAutoScroll) {
      lastInteractionRef.current = Date.now();
      startAutoScroll();
    }
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
    setStartY(e.touches[0].clientY);
    setCurrentX(e.touches[0].clientX);
    setCurrentY(e.touches[0].clientY);
    lastInteractionRef.current = Date.now();
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    
    const currentTouchX = e.touches[0].clientX;
    const currentTouchY = e.touches[0].clientY;
    
    // Calculate angle of swipe
    const deltaX = currentTouchX - startX;
    const deltaY = currentTouchY - startY;
    const angle = Math.abs(Math.atan2(deltaY, deltaX) * 180 / Math.PI);
    
    // Only allow horizontal swipes (angle < 45 degrees)
    if (angle < 45 || angle > 135) {
      setCurrentX(currentTouchX);
      e.preventDefault(); // Prevent vertical scrolling when swiping horizontally
    }
    
    lastInteractionRef.current = Date.now();
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);
    const diff = startX - currentX;
    const threshold = window.innerWidth / 4; // 25% of screen width

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        handleSlideChange(1);
      } else {
        handleSlideChange(-1);
      }
    }
    startAutoScroll();
  };

  const getTranslateX = () => {
    if (!isDragging) return -currentIndex * 100;
    const dragDistance = ((currentX - startX) / window.innerWidth) * 100;
    const newTranslate = -currentIndex * 100 + dragDistance;
    return newTranslate;
  };

  return (
    <div className="relative w-full h-screen overflow-hidden">
      <div
        ref={containerRef}
        className="absolute w-full h-full flex"
        style={{
          transform: `translateX(${getTranslateX()}%)`,
          transition: isTransitioning ? 'transform 300ms ease-out' : 'none',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {clonedImages.map((image, index) => (
          <div key={index} className="w-full h-full flex-shrink-0 relative">
            <picture>
              <source media="(min-width: 768px)" srcSet={image.src} />
              <source media="(max-width: 767px)" srcSet={image.srcMobile} />
              <img
                src={image.src}
                alt={`Slide ${index % images.length + 1}`}
                className="w-full h-full object-cover"
              />
            </picture>
            <div className="absolute inset-0 flex flex-col items-center justify-end bg-black bg-opacity-30 text-white">
              <h2 style={{fontWeight:'400'}} className="text-3xl font-fontc md:text-4xl lg:text-5xl mb-8 px-4 text-center">
                {image.text}
              </h2>
              <button className="mb-12 md:mb-24 px-6 py-2 bg-white text-black rounded-full font-semibold">
                <a href="https://api.whatsapp.com/send?phone=9130703656&text=Hello">{image.buttonText}</a>
              </button>
              <div className="mb-8 md:mb-16">
                <svg style={{transform:"scale(0.7)"}}
                  width="30"
                  height="17"
                  viewBox="0 0 30 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.5482 0.000909049L30 2.45503L16.6376 15.822C16.4235 16.0375 16.1689 16.2085 15.8884 16.3252C15.608 16.4419 15.3072 16.502 15.0035 16.502C14.6997 16.502 14.3989 16.4419 14.1185 16.3252C13.838 16.2085 13.5834 16.0375 13.3693 15.822L0 2.45503L2.45181 0.00322191L15 12.5491L27.5482 0.000909049Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}






const infiniteScrollImages = [
  { src: img1, width: 300 },
  { src: img2, width: 400 },
  { src: img1, width: 300 },
  { src: img2, width: 350 },
  { src: img1, width: 550 },
  { src: img2, width: 350 },
  { src: img1, width: 350 },
  { src: img2, width: 300 },
];



function App() {
  const [loading, setLoading] = useState(true);
  const [carouselLoaded, setCarouselLoaded] = useState(false); // To check if carousel images are loaded
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  useEffect(() => {
    // Simulate minimum loader delay of 2 seconds
    const timer = setTimeout(() => {
      setLoading(false); // Hide loader after 2 seconds (even if the carousel is not loaded yet)
    }, 20000000000); 

    // Clean up timeout when component is unmounted
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    // Check if carousel images are loaded
    const checkImagesLoaded = () => {
      // Here we assume you check the loading state of the images
      const allImagesLoaded = images.every((image, index) => {
        const img = new Image();
        img.src = image.src;
        return img.complete; // Check if image is fully loaded
      });
      if (allImagesLoaded) {
        setCarouselLoaded(true); // Set carousel as loaded if all images are loaded
      }
    };
    // Run the image check function
    checkImagesLoaded();
  }, []); // Run once on mount
  useEffect(() => {
    // If carousel is loaded and the minimum loader time has passed, hide the loader
    if (carouselLoaded && !loading) {
      setLoading(false);
    }
  }, [carouselLoaded, loading]); // Dependency on both carouselLoaded and loading states

  return (
    <Router>
      <div className="main">
        {/* Show Loader while loading is true */}
        {loading && <Loader />}
        <Header toggleModal={toggleModal} isModalOpen={isModalOpen}/>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <Routes>
          <Route path="/" element={<Carousel />} />
          {/* Add more routes here as needed */}
        </Routes>
       
        <div>
          <SmoothScrollHero />
        </div>
        <div id="portfolio" className="mb-10 bg-[#f9f4ee]">
          <PortfolioCarousel />
        </div>
        <div className='py-4' id="gallery">
          <InfiniteScroll images={infiniteScrollImages} />
        </div>
        <div id="contact">
          <ContactSection />
        </div>
        <FooterWithSocialLinks />
      </div>
    </Router>
  );
}


export default App;
